import * as optionActions from '../actions/Options';

const initialState = {
  listGroups: [
    {
      groupId: '0',
      groupName: '選択なし',
      groupYype: 'OTHERS',
      isAllowCreateChildMenu: 0
    }
  ],
  listShops: [
    {
      shopId: '0',
      shopName: '選択なし',
      childShopFlag: 0,
      isAllowCreateChildMenu: 0
    }
  ]
};

const options = (state = initialState, action) => {
  switch (action.type) {
    // case optionActions.GET_SHOPS_SUCCESS:
    //   return Object.assign({}, state.listShops, action.payload.list);
    // case optionActions.GET_SHOPS_FAILURE:
    //   return Object.assign({}, state, {
    //     status: action.payload,
    //     error: action.error
    //   });
    case optionActions.GET_SHOPS_SUCCESS:
      return Object.assign({}, state, {
        listShops: action.payload.list
      });
    case optionActions.GET_SHOPS_FAILURE:
      return Object.assign({}, state, {
        status: action.payload,
        error: action.error
      });

    case optionActions.GET_GROUPS_SUCCESS:
      return Object.assign({}, state, {
        listGroups: action.payload.list
      });
    case optionActions.GET_GROUPS_FAILURE:
      return Object.assign({}, state, {
        status: action.payload,
        error: action.error
      });

    case optionActions.GET_MENU_GENRE_SUCCESS:
      return Object.assign({}, state, {
        listMenuGenre: action.payload.list
      });
    case optionActions.GET_MENU_GENRE_FAILURE:
      return Object.assign({}, state, {
        status: action.payload,
        error: action.error
      });

    case optionActions.GET_MENU_SITUATION_SUCCESS:
      return Object.assign({}, state, {
        listMenuSituation: action.payload.list
      });
    case optionActions.GET_MENU_SITUATION_FAILURE:
      return Object.assign({}, state, {
        status: action.payload,
        error: action.error
      });

    case optionActions.GET_MENU_USER_TARGET_SUCCESS:
      return Object.assign({}, state, {
        listMenuUserTarget: action.payload.list
      });
    case optionActions.GET_MENU_USER_TARGET_FAILURE:
      return Object.assign({}, state, {
        status: action.payload,
        error: action.error
      });
    default:
      return state;
  }
};

export default options;
